export default {
	gtm:{ 
        "affiliate": "jansonmedia",
		"code": 'GTM-NCNS68C' 
	}
};